var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"yi4H_k3G7u7LjN01ARYB9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frojdse@frojd-interactive-ab"]={id:"yi4H_k3G7u7LjN01ARYB9"};
      